import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import DashboardHeader from "@/components/membership/Dashboard/DashboardComponents/DashboardHeader";
import SubmittedFilesTable from "@/components/membership/Dashboard/DashboardTables/SubmittedFilesTable/SubmittedFilesTable";
import SubmittedFilesTableFilters from "@/components/membership/Dashboard/DashboardTables/SubmittedFilesTable/SubmittedFilesTableFilters";
import {
  updateDashboard,
  getLocalsFromDashboardFiles,
} from "@/components/membership/Dashboard/DashboardUtils/DashboardUtil";
import "./Dashboard.css";

function Dashboard({ dashboardData }) {
  const [filter, setFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownLocals, setDropdownLocals] = useState([]);
  const [selectedLocal, setSelectedLocal] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [updatedDashboard, setUpdatedDashboard] = useState(undefined);

  useEffect(() => {
    setUpdatedDashboard(updateDashboard(dashboardData));
    setDropdownLocals(getLocalsFromDashboardFiles(dashboardData.files));
  }, [dashboardData]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleSelectedLocalChange = (e, selectedLocal) => {
    if (selectedLocal) {
      setSelectedLocal(selectedLocal);
    } else {
      setSelectedLocal("");
    }
  };

  const handleFilterChange = (newFilter) => {
    if (newFilter === "clear") {
      setSearchTerm("");
      setStartDate(null);
      setEndDate(null);
      setSelectedLocal("");
    }
    setFilter(newFilter);
  };

  const tableprops = {
    dashboardData: updatedDashboard,
    filter,
    searchTerm,
    startDate,
    endDate,
    selectedLocal,
  };
  const filterTableProps = {
    searchTerm,
    setSearchTerm,
    selectedLocal,
    dropdownLocals,
    handleSelectedLocalChange,
    handleFilterChange,
    startDate,
    endDate,
    handleEndDateChange,
    handleStartDateChange,
  };

  return (
    <Box sx={{ width: "100%" }}>
      {updatedDashboard && (
        <DashboardHeader
          onFilterChange={handleFilterChange}
          filter={filter}
          dashboard={updatedDashboard}
        />
      )}
      <SubmittedFilesTableFilters {...filterTableProps} />
      {updatedDashboard && <SubmittedFilesTable {...tableprops} />}
    </Box>
  );
}

Dashboard.propTypes = {
  dashboardData: PropTypes.object,
};

export default Dashboard;
